<!--
    描述：附件使用示例
    时间：2020-10-13
    Created by ws
-->
<template>
	<div class="example-layout">
		<!-- 具体实例 -->
		<div class="example-box">
			<div class="example-title">
				非图片模式示例
			</div>
			<div class="example-content">
				<el-row :gutter="20">
					<el-col :span="12">
						<h3>实例</h3>
						<my-upload ref="zzUpload"
								   :maxNum="1"
								   tableName="sys_tenant"
								   assortment="baseInfo_1"
								   :aid="formObj.id">
						</my-upload>
					</el-col>
					<el-col :span="12">
						<h3>代码</h3>
						<pre v-highlight>
							<code>
	&lt;my-upload ref="zzUpload"
		:maxNum="1"
		tableName="sys_tenant"
		assortment="baseInfo_2"
		:aid="formObj.id"&gt;
	&lt;/my-upload&gt;
							</code>
						</pre>
					</el-col>
				</el-row>
			</div>
		</div>

		<div class="example-box">
			<div class="example-title">
				图片模式示例
			</div>
			<div class="example-content">
				<el-row :gutter="20">
					<el-col :span="12">
						<h3>实例</h3>
						<my-upload ref="zzUpload"
								   :maxNum="1"
								   tableName="sys_tenant"
								   assortment="baseInfo_2"
								   :aid="formObj.id"
								   listType="picture-card"
								   :acceptType="picType">
						</my-upload>
					</el-col>
					<el-col :span="12">
						<h3>代码</h3>
						<section class="border-box">
							<pre v-highlight>
								<code>
	&lt;my-upload ref="zzUpload"
		:maxNum="1"
		tableName="sys_tenant"
		assortment="baseInfo_2"
		:aid="formObj.id"
		listType="picture-card"
		:acceptType="picType"&gt;
	&lt;/my-upload&gt;
								</code>
							</pre>
						</section>
					</el-col>
				</el-row>
			</div>
		</div>

		<!-- 代码说明 -->
		<div class="example-box">
			<div class="example-title">
				上传组件属性说明
			</div>
			<div class="example-content">
<!--				<myMarkdown v-highlight></myMarkdown>-->
			</div>
		</div>
	</div>
</template>

<script>
export default {
	components: {
/*		myMarkdown: () => import('./upload.md')*/
	},
	data() {
		return {
			formObj: {
				id: ''
			}
		}
	},
	computed: {
		picType() {
			return ['jpg', 'jpeg', 'png']
		}
	}
}
</script>

<style scoped lang="less">
.border-box {
	border: 1px solid #bed2ea;
	// height: 250px;
}

pre {
	display: flex;
	code {
		flex: 1;
	}
}
</style>
